import { render, staticRenderFns } from "./SelfServicePanel.vue?vue&type=template&id=397c6017"
import script from "./SelfServicePanel.vue?vue&type=script&lang=js"
export * from "./SelfServicePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports